import { render, staticRenderFns } from "./BudgetLimit.vue?vue&type=template&id=7b9edb77&scoped=true&"
import script from "./BudgetLimit.vue?vue&type=script&lang=js&"
export * from "./BudgetLimit.vue?vue&type=script&lang=js&"
import style0 from "./BudgetLimit.vue?vue&type=style&index=0&id=7b9edb77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9edb77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b9edb77')) {
      api.createRecord('7b9edb77', component.options)
    } else {
      api.reload('7b9edb77', component.options)
    }
    module.hot.accept("./BudgetLimit.vue?vue&type=template&id=7b9edb77&scoped=true&", function () {
      api.rerender('7b9edb77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget-control/instance/components/BudgetLimit.vue"
export default component.exports